<admin-header></admin-header>
<html>
  <router-outlet></router-outlet>
</html>
